import script from "./card-shop.vue?vue&type=script&lang=ts&setup=true"
export * from "./card-shop.vue?vue&type=script&lang=ts&setup=true"

import "./card-shop.vue?vue&type=style&index=0&id=7dd94107&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd94107"]])

export default __exports__